import {FC} from 'react';
import {useCan} from 'src/permissions/hooks';
import {IconButton, Stack} from '@mui/material';
import {Delete} from '@mui/icons-material';
import {EditIcon} from '../../../../icons/EditIcon';
import {ReOwnerActionsProps} from './ReOwnerActions.types';
import {reOwnerActionsSx} from './ReOwnerActions.sx';

export const ReOwnerActions: FC<ReOwnerActionsProps> = ({
    realEstateId,
    onUpdate,
    onDelete,
}) => {
    const handleUpdateClick = () => {
        onUpdate(realEstateId);
    };

    const handleDeleteClick = () => {
        onDelete(realEstateId);
    };

    // The permissions the two endpoints behind these icons check. Neither was asked, so a viewer who
    // may only read properties was still offered a pencil and a bin.
    const canUpdate = useCan('realEstates.update');
    const canDelete = useCan('realEstates.delete');

    return (
        <Stack sx={reOwnerActionsSx.root}>
            {canUpdate && (
                <IconButton
                    sx={reOwnerActionsSx.button}
                    onClick={handleUpdateClick}
                >
                    <EditIcon/>
                </IconButton>
            )}

            {canDelete && (
                <IconButton
                    sx={reOwnerActionsSx.button}
                    onClick={handleDeleteClick}
                >
                    <Delete sx={reOwnerActionsSx.icon}/>
                </IconButton>
            )}
        </Stack>
    );
};